
const initialState = {
  loading: false,
  newPass: false,
  error: false,
  adminListing: [],
  adminDetail: null,
  totalAdmin: 0,

};

const adminReducer = (state = initialState, action) => {
  // console.log("admin  reducers------", state, action);
  switch (action.type) {
    case "ADD_ADMIN_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_ADMIN_SUCCESS":
      return {
        ...state,
        loading: false,
        newPass: true,
        error: false,
      };
    case "ADD_ADMIN_FAILED":
      return {
        ...state,
        loading: false,
        newPass: false,
        error: true,
      };

    case "GET_ADMIN_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_ADMIN_REQUEST_FAILED":
      return {
        ...state,
        error: true,
      };
    case "GET_ADMIN_REQUEST_SUCCESS":
      return {
        ...state,
        adminListing: action.payload,
        totalAdmin: action.total,

        loading: false,
      };

    case "GOT_ADMIN_DETAIL":
      return {
        ...state,
        adminDetail: action.payload,
      };
    default:
      return state;
  }
};

export default adminReducer;
